function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.088 24.687v10.724c1.61-1.631 5.255-4.122 10.843-6.114v28.635h7.388V27.28c3.617-.715 7.732-1.163 12.333-1.163v-3.575c-5.839-.715-20.126-1.287-30.564 2.145zM52.043 57.872c-.596-11.876 4.766-35.627 33.244-35.627v35.627H77.9V45.362H63.293c-.69 3.525-1.102 7.66-1.102 12.512H52.043zM77.9 25.223s-9.452 1.614-13.692 16.325H77.9V25.223zm76.737-2.979c28.478 0 33.84 23.752 33.245 35.628h-10.149c0-4.85-.412-8.986-1.102-12.511a44.6 44.6 0 00-.915-3.813c-4.24-14.711-13.692-16.325-13.692-16.325v32.65h-7.387V22.245zm-2.86 17.874c0 10.003-8.242 18.112-18.41 18.112a18.502 18.502 0 01-13.135-5.422l2.173-2.025c2.74 4.17 10.962 6.732 15.907 1.787 6.168-6.168 3.218-12.035 1.966-14.299l8.554-7.983a17.819 17.819 0 012.945 9.83zm-36.819 0c0 3.624 1.081 7 2.945 9.83l8.672-8.102c-3.157-4.35-2.323-12.273 3.396-15.312 7.621-4.049 11.856.179 14.418 2.8l2.114-1.906a18.506 18.506 0 00-13.136-5.422c-10.167 0-18.409 8.11-18.409 18.112z",
  fill: "#C0C3C9"
});

var SvgAtolG = function SvgAtolG(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 240 80",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAtolG, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/atol_g.c1f5ec1e.svg";
export { ForwardRef as ReactComponent };